import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PublishProjectDialogComponent } from './publish-project-dialog.component';

@Injectable({providedIn: 'root'})
export class PublishProjectDialogService {
  private dialog = inject(MatDialog);


  openPublishChangesWindow(projectKey: string): MatDialogRef<PublishProjectDialogComponent> {
    return this.dialog.open<PublishProjectDialogComponent, string>(PublishProjectDialogComponent, {
      panelClass: 'big-dialog',
      disableClose: true,
      closeOnNavigation: false,
      autoFocus: false,
      data: projectKey
    });
  }
}
